const constants = {
    apiHost: process.env.VUE_APP_apiHost,
    domain: process.env.VUE_APP_domain,
    cookieScope: process.env.VUE_APP_cookieScope,
    url: process.env.VUE_APP_url,
    s3Bucket: process.env.VUE_APP_s3Bucket,
    parserAPI: process.env.VUE_APP_parserAPI,
    personalityAPI: process.env.VUE_APP_personalityAPI,
    loginServiceUrl: process.env.VUE_APP_loginServiceUrl,
    acticsServiceUrl: process.env.VUE_APP_acticsServiceUrl,
    commServiceUrl: process.env.VUE_APP_commServiceUrl,
    feedServiceUrl: process.env.VUE_APP_feedServiceUrl,
    connServiceUrl: process.env.VUE_APP_connServiceUrl,
    paymentsServiceUrl: process.env.VUE_APP_paymentsServiceUrl,
    coachServiceUrl: process.env.VUE_APP_coachServiceUrl,
    hibobIntegrationServiceUrl: process.env.VUE_APP_hibobIntegrationServiceUrl,
    platformServiceUrl: process.env.VUE_APP_platformServiceUrl,
    coachIntegrationServiceUrl: process.env.VUE_APP_coachIntegrationServiceUrl,
    parserFeedbackApi: process.env.VUE_APP_parserFeedbackApi,
    gatewayServiceUrl: process.env.VUE_APP_gatewayServiceUrl,
    gatewayUrl: process.env.VUE_APP_gatewayUrl,
    facebookGraphUrl: process.env.VUE_APP_facebookGraphUrl,
    slackUrl: process.env.VUE_APP_slackUrl,
    discordApi: process.env.VUE_APP_discordApi,
    twitterApi: process.env.VUE_APP_twitterApi
};

export default constants;
